import React, { useState } from 'react'
import styled from 'styled-components'
import { Row, Col, Button, Form } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'

import { SIZES } from '../../styles/theme'
import Axios from 'axios'
import config from '../../config'
import { toast } from 'react-toastify'
import routes from '../../routes'
import { fixedAssets } from 'src/containers/PreCache'

const Page = styled.div`
  min-height: 100vh;
  background-image: url(${fixedAssets.regBg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding: 0;
  padding-bottom: 2em;
  color: #000000;
  text-align: center;
  height: 100%;

  .mobile-show {
    display: none;
  }
  .visual {
    position: absolute;
    width: 15%;
    animation: floating 4s infinite linear;
  }
  #growth {
    top: 20%;
    left: 5%;
  }
  #comfort {
    top: 10%;
    left: 83%;
  }
  #cognition {
    top: 75%;
    left: 78%;
  }

  .row {
    select.form-input {
      text-align-last: center;
    }

    h6.subtitle {
      color: #fff;
      font-size: 28px;
      font-weight: 700;
      padding: 0 10px;
    }
    .error-message {
      font-weight: 500;
      color: yellow;
    }

    .register-form {
      .form-group {
        width: 100%;
        margin: 18px auto;
        margin-bottom: 0;
        background: #FFFFFF;
        border: none;
        border-radius: 6px;
        font-weight: 600;
        text-align: center;
        padding-right: 8px;
        input[type='tel'],
        .form-input {
          display: block;
          color: #4D4D4D;
          width: 100%;
          font-weight: 500;
          background: transparent;
          border: none;
          padding: 14px 8px;
          outline: none;
          text-align: center;
          font-size: 14px;
          &::placeholder {
            color: #4D4D4D;
            font-size: 14px;
          }
        }
      }
    }
  }
  .form-container {
    padding: 0 10px;
  }
  ${SIZES.mobile} {
    background-image: url(${fixedAssets.regBg});
    padding: 0;
    padding-bottom: 2.5em;
    padding-top: 1em;
    font-size: 0.9em;
    .mobile-show {
      display: block;
    }
    .mobile-hide {
      display: none;
    }
    .subtitle, .error-message {
      padding: 0;
      font-size: 14px;
      text-align: center;
    }
    h6.subtitle {
      font-size: 28px !important;
    }
    .col-md-5, .col-md-6 {
      flex: none;
      max-width: 100%
    }
  }
  .optional {
    margin: 12px 0;
    label {
      color: #fff;
      font-size: 14px;
      font-weight: 500;
    }
    textarea {
      display: block;
      color: #4D4D4D;
      border-radius: 6px;
      width: 100%;
      font-weight: 500;
      background: #fff;
      border: none;
      padding: 8px 14px;
      outline: none;
      font-size: 14px;
      &::placeholder {
        color: #4D4D4D;
        font-size: 14px;
      }
    }
  }
  div.privacy {
    margin: 0 auto;
    width: 95%;
    margin-top: 32px;
    color: #fff;
    .form-check {
      display: flex;
      align-items: flex-start;
      padding: 0;
      font-weight: 500;
      
      .form-check-label {
        font-size: 14px;
        margin-left: 8px;
        a {
          text-decoration: underline;
        }
      }
    }
  }

  button.submit-btn {
    background: linear-gradient(#AB48FF, #29005A);
    box-shadow: 0 5px 4px -4px #000000;
    width: 25%;
    color: #FFFFFF;
    font-weight: 600;
    border: none;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    padding: 8px 18px;
    margin: 16px auto;
    margin-right: 0;
    font-size: 1.2em;
    outline: none;

    ${SIZES.mobile} {
      width: 100%;
      padding: 10px 24px;
    }
    &:disabled {
      cursor: not-allowed;
      background: grey;
    }
    div {
      line-height: 32px;
    }
  }
`

export default function RegisterFormPage() {
  const history = useHistory()

  const [loading, setLoading] = useState(false)
  const [salutation, setSalutation] = useState('')
  const [fullName, setFullName] = useState('')
  const [icNo, setIcNo] = useState('')
  const [mmc, setMmc] = useState('')
  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')
  const [profession, setProfession] = useState('')
  const [others, setOthers] = useState('')
  const [placeOfPractice, setPlaceOfPractice] = useState("")
  const [state, setState] = useState("")
  const [sector, setSector] = useState("")
  const [question, setQuestion] = useState("")
  const [webinar, setWebinar] = useState("")

  const [emailFormatted, setEmailFormatted] = useState(true)
  const [validationError, setValidationError] = useState(false)

  const titleList = ['Mr', 'Mrs', 'Ms', 'Madam', 'Datuk', 'Dato', 'Datin', 'Prof.', 'Assoc. Prof.', 'Dr']
  const professionList = ['General Practitioner', 'Paediatrician', 'Dietitian', 'Family Medicine Specialist', 'Medical Officer', 'Nutritionist', 'Other']
  const stateList = ['Selangor', 'Kuala Lumpur', 'Sarawak', 'Johor', 'Sabah', 'Penang', 'Perak', 'Pahang', 'Negeri Sembilan', 'Kedah', 'Malacca', 'Terengganu', 'Kelantan', 'Labuan', 'Perlis', 'Putrajaya / Cyberjaya' ]
  const sectorList = ['Private', 'Government']
  const _stateList = stateList.sort((a, b) => a.localeCompare(b))

  const handleEmailInput = (e) => {
    setEmail(e.target.value.toLowerCase())
    const regexExp = /\S+@\S+\.\S+/
    const validatedEmail = regexExp.test(e.target.value)
    if (validatedEmail) {
      setEmailFormatted(true)
    } else {
      setEmailFormatted(false)
    }
  }

  const handleNric = (e) => {
    const ic_number = e.target.value
    setIcNo(ic_number.substring(0, 12))
  }

  const handlePhoneNumber = (e) => {
    const phone_number = e.target.value
    setPhone(phone_number.substring(0, 11))
  }

  const handleOther = (e) => {
    setProfession(e.target.value)
    setOthers("")
  }
  const validated = emailFormatted

  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)
    if (!hasEmptyField && validated) {
      let finalProfession = profession
      if (profession === 'Other') {
        finalProfession = others.trim()
      }
      const options = {
        title: salutation,
        full_name: fullName.trim(),
        nric: icNo.trim(),
        mmc: mmc.trim(),
        phone: phone.trim(),
        email,
        profession: finalProfession,
        place_of_practice: placeOfPractice.trim(),
        state,
        sector,
        question: question.trim(),
        hear_about: webinar.trim(),
      }
      Axios.post(`${config.apiUrl}/api/register`, options)
        .then(() => {
          setLoading(false)
          history.push(routes.postRegister)
        })
        .catch((err) => {
          setLoading(false)
          toast(err.response.data.message)
        })
    } else {
      setValidationError(true)
      setLoading(false)
      toast('Please ensure all fields are filled in accurately before proceeding')
    }
  }

  const hasEmptyField = !(
    salutation.length &&
    fullName.length &&
    icNo.length &&
    mmc.length &&
    phone.length &&
    email.length &&
    profession.length &&
    ((profession === 'Other') == (others.length > 0)) &&
    placeOfPractice.length &&
    state.length &&
    sector.length
  )

  return (
    <Page>
      <Row id="main" noGutters className="px-4 pt-0 pb-3">
        <img width="100%" src={fixedAssets.kvTitleM} alt="event-banner" className="d-md-none d-block mx-auto" />
        <img width="100%" src={fixedAssets.kvTitle} alt="event-banner" className="d-none d-md-block mx-auto" />
        <img src={fixedAssets.growth} alt="event-visual" id="growth" className="visual mobile-hide" />
        <img src={fixedAssets.cognition} alt="event-visual" id="cognition" className="visual mobile-hide" />
        <img src={fixedAssets.comfort} alt="event-visual" id="comfort" className="visual mobile-hide" />

        <Col md={3} className="mobile-hide"></Col>

        <Col md={6} className="text-left">
          <h6 className="subtitle">Registration Form</h6>
         
          <Row className="register-form" noGutters>
            <Col md={6} className="form-container">
              <Form.Group>
                <select
                  className="form-input"
                  value={salutation}
                  name="salutation"
                  onChange={(e) => setSalutation(e.target.value)}
                >
                  <option value="" disabled selected hidden>Title *</option>
                  {titleList.map((item, i) => (
                    <option key={`option-${i}`} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Form.Group>
              <Form.Group>
                <input
                  className="form-input"
                  required
                  type="text"
                  placeholder='Full Name as per IC *'
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </Form.Group>

              <Form.Group>
                <input
                  className="form-input"
                  type="text"
                  placeholder="IC Number *(for CPD points)"
                  value={icNo}
                  onChange={(e) => handleNric(e)}
                />
              </Form.Group>

              <Form.Group>
                <input
                  className="form-input"
                  type="text"
                  value={mmc}
                  placeholder="MMC Number *(for CPD points)"
                  onChange={(e) => setMmc(e.target.value)}
                />
              </Form.Group>
              <Form.Group>
                <input
                  className="form-input"
                  required
                  type="text"
                  value={phone}
                  placeholder="Mobile Number *"
                  onChange={(e) => handlePhoneNumber(e)}
                />
              </Form.Group>

              <Form.Group>
                <input
                  className="form-input"
                  required
                  type="email"
                  value={email}
                  placeholder="Email Address *"
                  onChange={handleEmailInput}
                />
              </Form.Group>
              {validationError && !email.length && <p className="error-message m-0">* Email Address is required.</p>}
              {!emailFormatted && <p className="error-message">* Please ensure email address format is valid</p>}

              <Form.Group>
                <select
                  className="form-input"
                  value={profession}
                  name="profession"
                  onChange={handleOther}
                >
                  <option value="" disabled selected hidden>Profession *</option>
                  {professionList.map((item, i) => (
                    <option key={`profession-${i}`} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Form.Group>
              {profession === 'Other' &&
                <Form.Group>
                  <input
                    className="form-input"
                    required
                    type="text"
                    value={others}
                    placeholder="Other, please specify."
                    onChange={(e) => setOthers(e.target.value)}
                  />
                </Form.Group>
              }
            </Col>

            {/* form right side */}
            <Col md={6} className="form-container">
              <Form.Group>
                <input
                  className="form-input"
                  required
                  type="text"
                  value={placeOfPractice}
                  placeholder="Place of Practice *"
                  onChange={(e) => setPlaceOfPractice(e.target.value)}
                />
              </Form.Group>
              <Form.Group>
                <select
                  className="form-input"
                  value={state}
                  name="state"
                  onChange={(e) => setState(e.target.value)}
                >
                  <option value="" disabled selected hidden>State *</option>
                  {_stateList.map((item, i) => (
                    <option key={`state-${i}`} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Form.Group>
              <Form.Group>
                <select
                  className="form-input"
                  value={sector}
                  name="sector"
                  onChange={(e) => setSector(e.target.value)}
                >
                  <option value="" disabled selected hidden>Sector *</option>
                  {sectorList.map((item, i) => (
                    <option key={`sector-${i}`} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Form.Group>
              <div className='optional'>
                <label>Do you have any questions for the speakers?</label>
                <textarea value={question} onChange={(e) => setQuestion(e.target.value)} placeholder="Type here..."></textarea>
              </div>
              <div className='optional'>
                <label>How did you hear about this webinar?</label>
                <textarea value={webinar} onChange={(e) => setWebinar(e.target.value)} placeholder="Type here..."></textarea>
              </div>
              {hasEmptyField && <p className="error-message m-0">* Please fill in the required field to proceed.</p>}
            </Col>
            <div className="privacy mb-2">
              <div className="form-check">
                <label className="form-check-label text-left">
                  <span className="text-danger">*</span>&nbsp; By filling in this form, you also agree to be bound by following Abbott Laboratories (M) Sdn Bhd <b>Privacy Policy</b> accessible at the link &nbsp; 
                  <a href="https://www.my.abbott/privacy-policy.html" target="_blank" rel="noopener noreferrer">
                    https://www.my.abbott/privacy-policy.html
                  </a>.
                </label>
              </div>
            </div>
             
            {/* bottom */}
            <div className="w-100">
              <Button
                type="submit"
                className="submit-btn"
                variant="default"
                disabled={loading}
                onClick={handleSubmit}
              >
                <div>{loading ? 'Loading...' : 'SUBMIT'}</div>
              </Button>
            </div>
          </Row>
        </Col>
      </Row>
    </Page>
  )
}
